import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgAnotherFortClass = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 39"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M5.542 38.189v-1.444L0 23.871l19.786 1.725s-1.03 1.447 3.923 1.859h11.354l1.443-1.651V24.36h3.51v3.094h4.337v-11.56l-20.024 8.54 19.198-10.397h1.65v4.542h2.065v8.67h7.844v-.62h-.826v-3.305l-8.05-10.113.619-.413 7.018 8.463 1.445-.206.206-.825.827 1.031 1.031 3.716v-9.495l-.619-1.24h1.652V12.8h4.955v1.033h6.604V12.8h.826V9.082L71.6.208 72.22 0v7.844l1.652 3.305h2.681v2.683h1.24v-1.24h2.064v1.24l17.133.347v5.432l-1.032-.619v2.682h1.032v2.891h2.89V22.09h1.034v-4.13h2.476v6.401h3.303v-2.687h2.065l.824-.618-9.907-7.224.413-.515 9.909 7.236V18.58h3.3v-1.652h.622l.618-10.735 1.033-1.031 5.984.617 1.55 1.034 1.888 9.884h1.859l.072 2.295 3.097.828 2.476.822-.825 1.448v5.365h1.033v-4.13h1.858l.413 4.13h1.65v-9.083h2.476v8.878l.827-.207v-1.03h3.923v-9.498h18.992v8.029H200v6.629l-2.478 7.016z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgAnotherFortClass
